import { render, staticRenderFns } from "./WorkProcedureChild.vue?vue&type=template&id=4760598c&scoped=true&"
import script from "./WorkProcedureChild.vue?vue&type=script&lang=js&"
export * from "./WorkProcedureChild.vue?vue&type=script&lang=js&"
import style0 from "./WorkProcedureChild.vue?vue&type=style&index=0&id=4760598c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4760598c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4760598c')) {
      api.createRecord('4760598c', component.options)
    } else {
      api.reload('4760598c', component.options)
    }
    module.hot.accept("./WorkProcedureChild.vue?vue&type=template&id=4760598c&scoped=true&", function () {
      api.rerender('4760598c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/components/WorkProcedureChild.vue"
export default component.exports